import { render, staticRenderFns } from "./modalInformacionLeechero.vue?vue&type=template&id=38da8daa&scoped=true&"
import script from "./modalInformacionLeechero.vue?vue&type=script&lang=js&"
export * from "./modalInformacionLeechero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38da8daa",
  null
  
)

export default component.exports